import { render, staticRenderFns } from "./PaperComposing.vue?vue&type=template&id=6c45ec61&scoped=true"
import script from "./PaperComposing.vue?vue&type=script&lang=js"
export * from "./PaperComposing.vue?vue&type=script&lang=js"
import style0 from "./PaperComposing.vue?vue&type=style&index=0&id=6c45ec61&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c45ec61",
  null
  
)

export default component.exports